import React from 'react';
import { BotIcon, MailIcon, PhoneIcon, CheckCircleIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function OpenclawPricing() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5532">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-12 lg:p-16 relative overflow-hidden" data-id="element-5533">
        <div className="max-w-5xl mx-auto" data-id="element-5534">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-5535">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-5536">
              Simple pricing for your{' '}
              <span className="text-blue-600" data-id="element-5537">AI sales agent</span>
            </h2>
            <p className="text-lg text-slate-500 leading-relaxed" data-id="element-5538">
              Pay only for the successful outputs the agent generates. No
              enterprise contracts or hidden per-seat fees.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-5539">
            {/* Agent Workflows */}
            <div className="bg-slate-50 border border-slate-100 rounded-2xl p-8 flex flex-col" data-id="element-5540">
              <div className="flex items-center gap-3 mb-4" data-id="element-5541">
                <BotIcon className="w-5 h-5 text-slate-400" data-id="element-5542" />
                <h3 className="text-lg font-bold text-slate-900" data-id="element-5543">
                  Agent workflows
                </h3>
              </div>
              <p className="text-slate-600 mb-8 flex-grow" data-id="element-5544">
                Run natural language queries, score leads, and generate custom
                deliverables.
              </p>
              <div data-id="element-5545">
                <div className="flex items-baseline gap-2" data-id="element-5546">
                  <span className="text-4xl font-bold text-slate-900" data-id="element-5547">
                    Free
                  </span>
                </div>
                <p className="text-sm text-slate-500 mt-1" data-id="element-5548">
                  unlimited workflows
                </p>
              </div>
            </div>

            {/* Owner Emails */}
            <div className="bg-slate-50 border border-slate-100 rounded-2xl p-8 flex flex-col relative overflow-hidden" data-id="element-5549">
              <div className="absolute top-0 inset-x-0 h-1 bg-blue-600" data-id="element-5550" />
              <div className="flex items-center gap-3 mb-4" data-id="element-5551">
                <MailIcon className="w-5 h-5 text-blue-600" data-id="element-5552" />
                <h3 className="text-lg font-bold text-slate-900" data-id="element-5553">
                  Enriched emails & drafts
                </h3>
              </div>
              <p className="text-slate-600 mb-8 flex-grow" data-id="element-5554">
                Get verified owner emails and let the agent draft personalized
                outreach.
              </p>
              <div data-id="element-5555">
                <div className="flex items-baseline gap-2" data-id="element-5556">
                  <span className="text-4xl font-bold text-slate-900" data-id="element-5557">$6</span>
                </div>
                <p className="text-sm text-slate-500 mt-1" data-id="element-5558">
                  per 100 emails found
                </p>
              </div>
            </div>

            {/* Employee Phones */}
            <div className="bg-slate-50 border border-slate-100 rounded-2xl p-8 flex flex-col" data-id="element-5559">
              <div className="flex items-center gap-3 mb-4" data-id="element-5560">
                <PhoneIcon className="w-5 h-5 text-slate-400" data-id="element-5561" />
                <h3 className="text-lg font-bold text-slate-900" data-id="element-5562">
                  Direct phone numbers
                </h3>
              </div>
              <p className="text-slate-600 mb-8 flex-grow" data-id="element-5563">
                Access direct dials for multi-channel CRM sequences and cold
                calling.
              </p>
              <div data-id="element-5564">
                <div className="flex items-baseline gap-2" data-id="element-5565">
                  <span className="text-4xl font-bold text-slate-900" data-id="element-5566">$24</span>
                </div>
                <p className="text-sm text-slate-500 mt-1" data-id="element-5567">
                  per 100 phones found
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-16" data-id="element-5568">
            <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-5569">
              <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-5570" />
              <span data-id="element-5571">Pay only for valid results</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-5572">
              <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-5573" />
              <span data-id="element-5574">Free credits to start</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-5575">
              <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-5576" />
              <span data-id="element-5577">No credit card required</span>
            </div>
          </div>

          <div className="text-center" data-id="element-5578">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-5579">
              <Button href="http://app.openmart.com/register" variant="primary" size="lg" data-id="element-5580">
                Try for free
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}